import { Component, OnInit } from '@angular/core';
import { base64ToFile, Dimensions, ImageTransform } from 'ngx-image-cropper';
import { ImageCroppedEvent } from 'ngx-image-cropper/lib/interfaces/image-cropped-event.interface';
import { FileService } from '@app/services/files/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { PlatformLocation } from '@angular/common';
import { MemberService } from '@app/services/member.service';
@Component({
  selector: 'app-load-photo',
  templateUrl: './load-photo.component.html',
  styleUrls: ['./load-photo.component.css']
})
export class LoadPhotoComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  canvasRotation = 0;
  rangeValues: number[] = [-2, 2];
  size;
  filesize;
  ready = false;
  memberid;
  member;
  fileData: File = null;

  constructor(
    private fileService: FileService,
    private location: PlatformLocation,
    private memberService: MemberService,
    private router: Router,
    private route: ActivatedRoute,
    private snackbarService: SnackbarService) { }

  ngOnInit() {
    this.route.params.subscribe(p => {
      if (p) {
        this.memberid = p.id;
        if (this.memberid) {
          this.getMemberById(Number(this.memberid));
        }
      }
    });
  }

  getMemberById(memberid: number) {
    this.memberService.getMemberById2(memberid).subscribe(m => {
      this.member = m;
    });
  }

  fileProgress(event) {
    this.fileData = <File>event.target.files[0];
    const formData = new FormData();
    formData.append('uploadedFile', this.fileData);
    formData.append('originatingId', this.memberid);
    this.fileService.UploadMemberImage(formData).subscribe(response => {
      if (response) {
        this.snackbarService.openSnackBar('Fotot inlagt', null);
        this.memberService.timestamp.next(new Date());
        this.router.navigateByUrl('/memberform/id/' + this.memberid);
      }
    });
  }

  async save() {
    const res: Response = await fetch(this.croppedImage);
    const blob: Blob = await res.blob();
    const file = new File([blob], this.memberid + '.jpg', { type: 'image/jpeg' });
    const formData = new FormData();
    formData.append('uploadedFile', file);
    formData.append('originatingId', this.memberid);
    this.fileService.UploadMemberImage(formData).subscribe(response => {
      if (response) {
        this.snackbarService.openSnackBar('Fotot inlagt', null);
        this.memberService.timestamp.next(new Date());
        this.router.navigateByUrl('/memberform/id/' + this.memberid);
      }
    });
  }

  getFormData(file, memberid) {
    const formData = new FormData();
    formData.append('uploadedFile', file);
    formData.append('memberId', memberid);
    return formData;
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.filesize = Math.round((event.srcElement.files[0].size / 1024) * 10) / 10;
    if (this.filesize > 1000) {
      this.filesize = Math.round((this.filesize / 1024) * 10) / 10;
      this.filesize = this.filesize + ' Mb';
    } else {
      this.filesize = this.filesize + ' kB';
    }
    this.ready = true;
  }

  async imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.size = Math.round((base64ToFile(event.base64).size / 1024) * 10) / 10;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    this.ready = true;
  }

  loadImageFailed() {
    console.log('Load failed');
  }

  rotateLeft() {
    this.canvasRotation = this.canvasRotation - 45;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation = this.canvasRotation + 45;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

  zoomOut() {
    this.scale -= 1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += 1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  updateRotation() {
    this.transform = {
      ...this.transform,
      rotate: this.rotation
    };
  }

  cancel() {
    this.location.back();
  }
}
